import { useEffect, useState } from 'react';

export const useSuccessMessage = () => {
  const [successMessage, setSuccessMessage] = useState('');

  // Clear message when component unmounts or on user click
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (successMessage) {
        setSuccessMessage('');
      }
    }, 5000);

    // Effect to clear the message on user click
    const handleClick = () => {
      setSuccessMessage('');
    };

    if (!successMessage) {
      return;
    }
    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
      clearTimeout(timeout);
    };
  }, [successMessage]);

  return { successMessage, setSuccessMessage };
};
